/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Move_Snooze_FailedInputs */

const en_home_move_snooze_failed = /** @type {(inputs: Home_Move_Snooze_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The move changed meanwhile.`)
};

/**
* | output |
* | --- |
* | "The move changed meanwhile." |
*
* @param {Home_Move_Snooze_FailedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const home_move_snooze_failed = /** @type {((inputs?: Home_Move_Snooze_FailedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Move_Snooze_FailedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_move_snooze_failed(inputs)
});